var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1818 2H3.81818C2.81364 2 2 2.81364 2 3.81818V20.1818C2 21.1864 2.81364 22 3.81818 22H20.1818C21.1864 22 22 21.1864 22 20.1818V3.81818C22 2.81364 21.1855 2 20.1818 2ZM18.99 10.6127C18.8718 10.6236 18.7527 10.6309 18.6327 10.6309C17.2736 10.6309 16.0791 9.93273 15.3836 8.87545C15.3836 11.6473 15.3836 14.8018 15.3836 14.8545C15.3836 17.2955 13.4045 19.2736 10.9645 19.2736C8.52455 19.2727 6.54545 17.2936 6.54545 14.8536C6.54545 12.4127 8.52455 10.4345 10.9645 10.4345C11.0573 10.4345 11.1473 10.4427 11.2373 10.4482V12.6264C11.1464 12.6155 11.0582 12.5991 10.9645 12.5991C9.71909 12.5991 8.70909 13.6091 8.70909 14.8545C8.70909 16.1 9.71818 17.11 10.9645 17.11C12.2109 17.11 13.3109 16.1282 13.3109 14.8827C13.3109 14.8327 13.3327 4.72818 13.3327 4.72818H15.4136C15.6091 6.58909 17.1118 8.05818 18.99 8.19273V10.6127Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTiktok);
export default __webpack_public_path__ + "static/media/ic_tiktok.48df0f759ca6abdf7a4644b70a57c0bf.svg";
export { ForwardRef as ReactComponent };